import { rolesOf, useAuth } from "@/context/AuthContext";
import AdminDashboard from "@/pages/AdminDashboard";
import UserDashboard from "@/pages/UserDashboard";

/** Admins get the analytical dashboard; every other role gets the role-shaped one. */
export default function Dashboard() {
  const { user } = useAuth();
  return rolesOf(user).includes("admin") ? <AdminDashboard /> : <UserDashboard />;
}
